import type { MediaController } from "../adapters/types";
import { Skeleton } from "@/components/ui/skeleton";

interface YouTubePlayerProps {
  containerId: string;
  controller: MediaController | null;
}

export function YouTubePlayer({ containerId, controller }: YouTubePlayerProps) {
  return (
    <div className="overflow-hidden md:rounded-2xl">
      <div className="aspect-video relative">
        {!controller && (
          <Skeleton className="absolute inset-0 rounded-none" />
        )}
        <div className="h-full w-full">
          <div id={containerId} className="h-full w-full" />
        </div>
      </div>
    </div>
  );
}
